import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useErrorWithinPaper } from '../organisms/forms/PaperContainerErrorsHandler'
import { useFieldError } from '../../hooks/useFieldError'
import ErrorValidationMessage from './ErrorValidationMessage'

const Error = ({ name, className, showInfoIcon = false, touched = true }) => {
  const { error, gotError, input } = useFieldError(name, { touched })

  const context = useErrorWithinPaper()

  useEffect(() => {
    context?.setError(name, gotError)
  }, [gotError])

  useEffect(() => {
    return () => {
      context?.setError(input.name, false)
    }
  }, [])

  return gotError ? <ErrorValidationMessage error={error} className={className} showInfoIcon={showInfoIcon} /> : null
}

export default Error

Error.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  showInfoIcon: PropTypes.bool,
  touched: PropTypes.bool
}
